import { IS_SERVER_REAL } from "../config/global-config-store"

if (IS_SERVER_REAL) {
  console.log = () => {}
  console.debug = () => {}
  console.info = () => {}
}
